export default function (props) {
    let initialValues = {};
    let backPressed = false;

    return {
        created() {
            for (let prop of props) {
                initialValues[prop] = this[prop];
            }

            window.addEventListener('popstate', this.handlePopState);

            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                for (let prop of props) {
                    if (this[prop] !== initialValues[prop]) {
                        this[prop] = initialValues[prop];
                        next(false);
                        return;
                    }
                }
                next();
            });

            this.$once('hook:destroyed', () => {
                window.removeEventListener('popstate', this.handlePopState);
                unregisterRouterGuard();
            });
        },
        methods: {
            handlePopState(event) {
                if (!backPressed) {
                    backPressed = true;
                    history.pushState(null, null, null);
                } else {
                    backPressed = false;
                }

                // Handle closing of your modal here
                for (let prop of props) {
                    if (this[prop] !== initialValues[prop]) {
                        this[prop] = initialValues[prop];
                    }
                }
            }
        }
    }
}
